const quickhelpDetails = [
  {
    title: "Idegrendszeri reset",
    secondaryTitle: "Shiatsu és Bowen technika",
    listItems: [
      'váll-nyak-hátfeszültség, "beállt" izmok',
      "fejfájás,tarkótáji nyomás",
      "testi nyugtalanság, belső feszítés",
      "kimerültség,túlhajtottság",
      "folyamatos készenléti állapot",
      '"nem tudok leállni"',
      "stressz okozta izomfájdalmak",
    ],
  },
  {
    title: "Mentális csend",
    secondaryTitle: "Shiatsu és Indiai fejmasszázs technika",
    listItems: [
      "alvászavar, nehéz elalvás",
      'gondolatitúlpörgés, - "nem kapcsol ki az agyam"',
      "belső nyugtalanság, zaklatottság",
      "koncentrációs nehézség",
      "mentális fáradtság, túl sok információ",
      "stressz miatti fejfeszülés",
    ],
  },
  {
    title: "Kapcsolati stabilizálás",
    secondaryTitle: "Shiatsu és Metamorf masszázs technika",
    listItems: [
      "érzelmi kibillenés, hangulatingadozás",
      "kapcsolati feszültségek (párkapcsolat, család, munkahely)",
      "visszatérő konfliktusok",
      "nehézség a kommunikációban",
      '"nem találjuk a hangot"',
      "érzelmitúlterheltség",
      "belső bizonytalanság kapcsolódás közben",
    ],
  },
];
const arrangementDetails = [
  {
    title: "Testi rendeződés",
    secondaryTitle: "Shiatsu, Bowen technika és szakmai tanácsadás",
    listItems: [
      'tartós váll-nyak-hátfeszültség, "beállt" izmok',
      "visszatérő derék- vagy kereszcsonttfájás",
      "fejfájás,tarkótáji nyomás",
      "nehéz, fáradttestérzetreggel vagy nap végén",
      "alvási nehézség",
      "mellkasi vagy gyomorszoritás",
      "hamar jelentkező kifáradás",
    ],
  },
  {
    title: "Stresszoldó kapcsolódás",
    secondaryTitle:
      "Shiatsu, Indiai fejmasszázs technika és szakmai tanácsadás",
    listItems: [
      "érzelmitúlterheltség, belső feszültség",
      "nehézség az elengedésben",
      "stresszes, érzelmileg megterhelő időszak",
      "igény egy biztonságos, elvárásmentes térre",
      "vágy a megnyugvásra és az önmagadhoz való visszakapcsolódásra",
    ],
  },
  {
    title: "Középpontba érkezés",
    secondaryTitle:
      "Shiatsu, Metamorf masszázs technika és kronobiológiai elemzés",
    listItems: [
      "szétszórtság, fókuszvesztés",
      "döntési bizonytalanság",
      "belső irány hiánya",
      "élethelyzeti váltás, elágazás előtt állás",
      'érzés, hogy "nem vagyok a helyemen"',
      "igény a tisztább belső látásra és tudatosabb jelenlétre",
    ],
  },
];
const maintainDetails = [
  {
    title: "Stabil állapot",
    secondaryTitle: "Max 2 féle technika alkalmazása:",
    listItems: [
      "Shiatsu",
      "Bowen technika",
      "Metamorf",
      "Indiai fejmasszázs",
      "Szakmai tanácsadás",
    ],
  },
  {
    title: "A havi kezelés segít:",
    listItems: [
      "megtörni a visszacsúszást",
      "megerősíteni az új, kedvezőbb testi válaszokat",
      "stabilizálni az elindított változásokat",
    ],
  },
  {
    title: 'Az idegrendszer "emlékezik" a támogatásra',
    secondaryTitle: "A rendszeres, de nem túl sűrű inger:",
    listItems: [
      "fenntartja a paraszimpatikus túlsúlyt",
      "csökkenti a krónikus stresszválaszt",
      "segít, hogy a test könnyebben kapcsoljon",
      "nyugalmi-regeneráló állapotba",
    ],
  },
  {
    title: "A folyamatok rétegesen zajlanak",
    secondaryTitle: "Sok esetben nem egyszerre oldódik minden:",
    listItems: [
      "először testi tünetek",
      "később érzelmi feszülések",
      "majd mélyebb működési minták",
      'A havi szintentartás lehetőséget ad arra, hogy a következő "réteg" biztonságosan megjelenjen és rendeződjön.',
    ],
  },
  {
    title: "Megelőzés, nem tűzoltás",
    secondaryTitle: "A szintentartó kezelés:",
    listItems: [
      "csökkenti az újabb elakadások kialakulását",
      "megelőzi a túlterhelést",
      'sok esetben elkerülhetővé teszi az "SOS" állapotot',
    ],
  },
];
const engrossmentDetails = [
  {
    title: "Fizikális regeneráció",
    secondaryTitle:
      "Shiatsu, Bowen, Indiai fejmasszázs technika és szakmai tanácsadás",
    listItems: [
      'a tested folyamatosan fáradt, "nem áll helyre"',
      "a feszültség mélyen ül, nem oldódik ki könnyen",
      "gyorsan kimerülsz, hiába pihensz",
      "úgy érzed, már nem csak lazításra, hanem valódi regenerációra van szükséged",
    ],
  },
  {
    title: "Belső rendeződés",
    secondaryTitle:
      "Shiatsu, Metamorf technika, Kronobiológiai elemzés ésszakmai tanácsadás",
    listItems: [
      "belül feszült vagy, de nem tudod pontosan megfogalmazni",
      "régóta hordozol elakadásokat, meg nem oldott érzéseket",
      "változásra vágysz, nem csak megkönnyebbülésre",
      'szeretnéd, hogy "belül is a helyére kerüljenek a dolgok"',
    ],
  },
  {
    title: "Kapcsolati hangolás",
    secondaryTitle:
      "Shiatsu, Indiai fejmasszázs technika, Kronobiológiai elemzés és szakmai tanácsadás",
    listItems: [
      "ugyanazok a helyzetek ismétlődnek a kapcsolataidban",
      "könnyen túlfeszít, amit mások mondanak vagy tesznek",
      "nehéz tisztán kommunikálni, gyakran félrecsúszik a kapcsolódás",
      "szeretnél nyugodtabban jelen lenni másokkal",
    ],
  },
];

export const bundles = [
  {
    title: "Csomag ajánlat 30 - GYORSSEGÉLY",
    desc: "Rövid, célzott támogatás, rendszeres igénybevételre",
    duration: "30",
    singlePrice: "8.000",
    bundlePrice: "30.000",
    bundleDesc: (
      <>
        /4 alkalom <br className="d-xl-none" />
        (7-10 naponta)
      </>
    ),
    details: quickhelpDetails,
    color: "quickhelp",
  },
  {
    title: "Csomag ajánlat 60 - RENDEZŐDÉS",
    desc: "A test és a belső rendszerek tudatos újrahangolására ad teret",
    duration: "60",
    singlePrice: "16.000",
    bundlePrice: "40.000",
    bundleDesc: (
      <>
        /3 alkalom <br className="d-xl-none" />
        (2 heti rendszerességgel)
      </>
    ),
    details: arrangementDetails,
    color: "arrangement",
  },
  {
    title: "Csomag ajánlat 60 - SZINTENTARTÓ",
    desc: "Az elért állapot fenntartása, finom korrekció, megelőzés",
    duration: "60",
    singlePrice: "16.000",
    bundlePrice: "42.000",
    bundleDesc: (
      <>
        /3 alkalom <br />
        (havi rendszerességgel)
      </>
    ),
    details: maintainDetails,
    color: "maintain",
  },
  {
    title: "Csomag ajánlat 90 - ELMÉLYÜLÉS",
    desc: "A regeneráció mélyebb szintjeit érinti, elindítja a tartós változás folyamatát",
    duration: "90",
    singlePrice: "22.000",
    bundlePrice: "60.000",
    bundleDesc: (
      <>
        /3 alkalom <br className="d-xl-none" />
        (2 heti rendszerességgel)
      </>
    ),
    details: engrossmentDetails,
    color: "engrossment",
  },
];

export const disclaimer = (
  <>
    A módszerek az aktuális testi, mentális és érzelmi állapothoz igazítva
    kerülnek kiválasztásra és kombinálásra. A kezelések nem helyettesítik az
    orvosi ellátást. Nem terápia.
  </>
);

export const billing = (
  <>
    Minden kezelés alkalmával számlát állítok ki elektronikusan - és közvetlenül
    a kezelés végén email-ben küldöm el.
  </>
);

export const cashOnly = <>KÉSZPÉNZ FIZETÉSRE VAN CSAK LEHETŐSÉG.</>;
